<template>
  <td data-int="cart-cell-uom">
    <span v-if="item.partUnavailable">{{ $t('notAvailable') }}</span>
    <span v-else>{{ item.uom }}</span>
  </td>
</template>

<script>
export default {
  name: 'CartCellUom',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
